var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoPhotoIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 193,
    height: 193,
    viewBox: "0 0 193 193",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1772",
    "data-name": "Group 1772",
    transform: "translate(-844 -1925)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_234",
    "data-name": "Ellipse 234",
    transform: "translate(844 1925)",
    fill: "#969fae",
    stroke: "#3fb6e8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 96.5,
    r: 96.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 96.5,
    r: 96,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_44",
    "data-name": "Union 44",
    d: "M0,102V89.252c0-14.028,22.95-25.5,51-25.5s51,11.475,51,25.5V102ZM25.5,25.5A25.5,25.5,0,1,1,51,51,25.5,25.5,0,0,1,25.5,25.5Z",
    transform: "translate(890 1971)",
    fill: "#fff"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoPhotoIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/no-photo-icon.11c0359f15ee77149cd96074b1910221.svg";